import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/banner_left.png'
import _imports_1 from '@/assets/images/banner_right.png'


const _withScopeId = n => (_pushScopeId("data-v-859c0f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner-info" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mouseIco" }, [
  /*#__PURE__*/_createElementVNode("i")
], -1))
const _hoisted_4 = { class: "arrow-info" }
const _hoisted_5 = { class: "arrow-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = { class: "arrow-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Carousel, {
      class: "banner-list",
      ref: "carouselRef",
      autoplay: "",
      "after-change": _ctx.onChange,
      dots: false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "banner-item",
            key: item.id
          }, [
            _createElementVNode("img", {
              src: _ctx.state.path + item.savePath,
              alt: "",
              class: "icon"
            }, null, 8, _hoisted_2)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["after-change"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePrev && _ctx.handlePrev(...args))),
          src: _imports_0,
          alt: "",
          class: "arrow"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args))),
          src: _imports_1,
          alt: "",
          class: "arrow"
        }),
        _hoisted_8
      ])
    ])
  ]))
}